import { NavLink } from "react-router-dom";
import "../scss/logo.scss";

export const Logo = () => {
  return <NavLink to="/" className="logo-main"></NavLink>;
};
